import axios from 'components/Axios';
import { AddMore } from '../APIEndPoint';

const AddMoreSectionPostApi = (payload) => {
  const promise = axios.post(`${AddMore}`, payload);
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const UpdateAddMore = (payload, id) => {
  const promise = axios.put(`${AddMore}/${id}`, payload);
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const GetAddMoreById = () => {
  const getUsername = window.location.pathname.split('/');
  const currentUsername = getUsername?.[getUsername?.length - 1]?.trim();
  const promise = axios.get(`${AddMore}/byUserName/${currentUsername}`);
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const DeleteAddMore = (data) => {
  const promise = axios.delete(AddMore, {
    data:{
      ...data
    }
  });
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

export { AddMoreSectionPostApi, UpdateAddMore, GetAddMoreById, DeleteAddMore };
